<template>
    <div class="animated fadeIn mb-70">
        <div id="Dashboard">
            <!-- <b-row>
<b-col sm="6" lg="3">
<router-link :to="requestLink" class="card-text-black">
<b-card no-body  class="bg-success">
<b-card-body class="pb-0" :to="requestLink">
<h4 class="mb-0" role="presentation">{{requestsCount}}</h4>
<p>Requests</p>
</b-card-body>
<card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
</b-card>
</router-link>
</b-col>
<b-col sm="6" lg="3">
<router-link :to="responseLink" class="card-text-black">
<b-card no-body class="bg-warning">
<b-card-body class="pb-0">
<h4 class="mb-0" role="presentation">{{responsesCount}}</h4>
<p>Responses</p>
</b-card-body>
<card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
</b-card>
</router-link>
</b-col>
<b-col sm="6" lg="3">
<router-link :to="feedbackLink" class="card-text-black">
<b-card no-body class="bg-primary">
<b-card-body class="pb-0">
<h4 class="mb-0" role="presentation">{{ Math.round(satisfactionsAvg * 10) / 10}}</h4>
<p>Feedback</p>
</b-card-body>
<card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
</b-card>
</router-link>
</b-col>
<b-col sm="6" lg="3">
<router-link :to="memberLink" class="card-text-black">
<b-card no-body class="bg-info">
<b-card-body class="pb-0">
<h4 class="mb-0" role="presentation">{{membersCount}}</h4>
<p>Members</p>
</b-card-body>
<card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
</b-card>
</router-link>
</b-col>
</b-row> -->
            <!-- <b-card>
<b-row>
<b-col sm="5"> -->
            <!-- <h4 id="engagement" class="mb-0 custom-card-header-text"><router-link to='/engagement/stream' class="header_title">Engagement </router-link><img src="img/tooltip.png" v-b-tooltip.hover.bottom title="Daily engagement of advisors and members." height="12" alt="tooltip" /></h4> -->
            <!-- <h4 id="engagement" class="mb-0 custom-card-header-text">Engagement <img src="img/tooltip.png" v-b-tooltip.hover.bottom title="Daily engagement of advisors and members." height="12" alt="tooltip" /></h4>
</b-col>
<b-col sm="7" class="d-none d-md-block">
<b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
<b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
<b-form-radio class="mx-0" value="month">Month</b-form-radio>
<b-form-radio class="mx-0" value="year">Year</b-form-radio>
</b-form-radio-group>
</b-button-toolbar>
</b-col>
</b-row>
<router-link to='/engagement/stream' class="header_title">
<main-chart-example chartId="main-chart-01" class="chart-wrapper" style="height:300px;margin-top:40px;" :bind="true" :chartData="chartData" :options="chartOptions" counter-data="0" :field="selected"></main-chart-example>

</router-link>
</b-card> -->
            <b-row class="widgets">
                <!-- Site Visits Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="The number of visitors to your program pages">
                        <b-card @click="showSiteVisitorsTable" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-eye"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ visitorsCount }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Site Visits</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Questions Widget (formerly Requests) -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover
                        title="The number of questions submitted within your community">
                        <b-card @click="showRequestsTable" class="widget-card bg-success">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-question-circle"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ requestsCount }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Questions</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Alumni Contacted Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover
                        title="The number of advisors we emailed to share requests">
                        <b-card @click="showAlumniContactedStream" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="cil-envelope-closed"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ alumniContacted }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Alumni Contacted</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Email Opens Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover
                        title="Unique opens: people who opened a request at least once (repeat opens count once). Open rate: unique opens divided by Alumni Contacted.">
                        <b-card @click="showEmailOpensStream" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="cil-envelope-open"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">
                                    {{ emailOpen }} <span class="percentage" style="font-weight: 400;">({{
                                        (emailOpenPercentage || 0).toFixed(1) }}%)</span>
                                </div>
                            </div>
                            <small class="text-uppercase enlarged-description">Email Opens</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Email Clicks Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="Unique clicks: people who clicked in a request at least once (repeat clicks count once). CTR: unique clicks divided by Alumni Contacted.">
                        <b-card @click="showEmailClicksStream" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-cursor"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">
                                    {{ clickCount }} <span class="percentage" style="font-weight: 400;">({{
                                        (emailClickPercentage || 0).toFixed(1) }}%)</span>
                                </div>
                            </div>
                            <small class="text-uppercase enlarged-description">Email Clicks</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Alumni Engaged Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover
                        title="The number of alumni who accepted or declined a request">
                        <b-card @click="showAdvisorsEngagedResponses" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="cil-happy"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ alumniEngaged }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Alumni Engaged</small>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <!-- <b-row class="widgets">
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-envelope-open"></i>
</div>
<router-link :to='emailOpenLink'>
<div class="h1 text-muted text-right mb-4">
<i class="cil-envelope-open"></i>
</div>
</router-link>
<div class="h4 mb-0">{{emailOpen}}%</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The average email open rate for requests we are sending to advisors (30 days delayed).">Email Open on Requests</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="info" :value="emailOpen"/>
</b-card>
</b-col>
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-happy"></i>
</div>
<router-link :to="engagementRateLink">
<div class="h1 text-muted text-right mb-4">
<i class="cil-happy"></i>
</div>
</router-link>
<div class="h4 mb-0">{{engagementRate}}</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The average percent of advisors that accept, decline or refer a request (30 days delayed).">Responses</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="success" :value="engagementRate"/>
</b-card>
</b-col>
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-clock"></i>
</div>
<router-link :to="firstResponseLink">
<div class="h1 text-muted text-right mb-4">
<i class="cil-clock"></i>
</div>
</router-link>
<div class="h4 mb-0">{{firstResponse}}</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The average time (in hours) to receive a response from an advisor.">Hours To First Response</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="warning" :value="firstResponse"/>
</b-card>
</b-col>
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-gift"></i>
</div>
<router-link :to="responsePerRequestLink">
<div class="h1 text-muted text-right mb-4">
<i class="cil-gift"></i>
</div>
</router-link>
<div class="h4 mb-0">{{responsePerRequest ? responsePerRequest : 0}}</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The average number of responses received divided by number of requests (30 days delayed).">Responses per request</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="primary" :value="responsePerRequestPercentage"/>
</b-card>
</b-col>
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-star"></i>
</div>
<router-link :to="satisfactionLink">
<div class="h1 text-muted text-right mb-4">
<i class="cil-star"></i>
</div>
</router-link>
<div class="h4 mb-0">{{satisfactionData ? satisfactionData : 0}}</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The average, combined satisfaction score of advisors and members (out of 10).">Average Satisfaction</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="success" :value="satisfactionDataPercentage"/>
</b-card>
</b-col>
<b-col sm="6" md="2">
<b-card>
<div class="h1 text-right mb-4">
<i class="cil-people"></i>
</div>
<router-link :to="profileUpdateLink">
<div class="h1 text-muted text-right mb-4">
<i class="cil-people"></i>
</div>
</router-link>
<div class="h4 mb-0">{{profileUpdate ? profileUpdate : 0}}</div>
<small class="text-uppercase font-weight-bold" v-b-tooltip.hover.bottom title="The number of profile updates (or referrals to your directory).">Profile Data Updates</small>
<b-progress height={} class="progress-sm mt-3 mb-0" variant="info" :value="profileUpdate"/>
</b-card>
</b-col>
</b-row> -->
            <!-- <b-row v-if="selectedCommunity && selectedCommunity !== 'all'">
<b-col>
<div class="h4 mb-2">Traffic</div>
<div class="text-muted mb-4">{{ analyticsChartLabels[0] }} - {{ analyticsChartLabels[analyticsChartLabels.length-1] }}</div>
<analytics-line-chart-example :datasets="analyticsChartDatasets" :labels="analyticsChartLabels" :width="100" :height="300"/>
</b-col>
</b-row> -->
            <b-row class="widgets">
                <!-- Responses Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="The number of responses submitted by advisors">
                        <b-card @click="showResponsesTable" class="widget-card bg-warning">
                            <div class="h1 text-right mb-4">
                                <i class="cil-chat-bubble"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ engagementRate }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Responses</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Avg Response Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="Average number of responses per question">
                        <b-card class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-calculator"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ calculatedAvgResponse }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Avg Response</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Answered Questions Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="Percentage of questions that received at least one response">
                        <b-card class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-check-circle"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ answeredQuestionsPercent }}%</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Answered Questions</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Feedback Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover
                        title="Average of ALL feedback in the reporting period">
                        <b-card @click="showFeedback" class="widget-card bg-primary">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-arrow-repeat"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ satisfactionsAvg }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Feedback</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Profile Updates Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="All profile updates in the reporting period">
                        <b-card @click="showProfileUpdates" class="widget-card">
                            <div class="h1 text-right mb-4">
                                <i class="bi bi-person-badge"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ profileUpdates }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Profile Updates</small>
                        </b-card>
                    </div>
                </b-col>

                <!-- Donor Alerts Widget -->
                <b-col sm="6" md="2">
                    <div class="widget-wrapper" v-b-tooltip.hover title="The number of alerts sent to your team after an assigned prospect volunteered">
                        <b-card @click="showDonorAlertsStream" class="widget-card bg-info">
                            <div class="h1 text-right mb-4">
                                <i class="cil-diamond"></i>
                            </div>
                            <div class="h2 mb-0 enlarged-number">
                                <WidgetsCustomSkeleton :isVisible="isWidgetsLoading" />
                                <div v-if="!isWidgetsLoading" class="h2 mb-0">{{ donorAlerts }}</div>
                            </div>
                            <small class="text-uppercase enlarged-description">Donor Alerts</small>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
    <b-row>
        <b-col sm="12" lg="12">
            <b-card>
                <template slot="header">
                    <h2 class="mt-2 custom-card-header-text">Top Tags <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="The top 25 tags by count" alt="tooltip" height="12"/></h2>
                    <router-link class="float-right mt-12 view-more" :to="tagLink" aria-label="View more Top Tags">View more</router-link>
                </template>
                    <WordCloud :words="wordList" @tag-click="tagRequest" />
            </b-card>
        </b-col>
    </b-row>
          <!-- <b-row>
              <b-col sm="4" lg="4">
                  <b-card>
                  <template slot="header">
                      <h2 class="mt-2 custom-card-header-text">Top Members <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="The top 10 requesters for help ranked by engagement score." alt="tooltip" height="12"/></h2>
                      <router-link class="float-right mt-12 view-more" :to="memberLink" aria-label="View more Top Members">View more</router-link>
                  </template>
                      <b-card-body>
                          <v-client-table v-bind:data="topMembers" v-bind:columns="topMembersColumns" :options="topMembersOptions" id="dataTable" class="top_member">
                              <span slot="name" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
                                  {{props.row.name}}
                              </span>
                              <span slot="name" slot-scope="props" v-else-if="props.row.name">
                                  {{props.row.name}}
                              </span>
                          </v-client-table>
                      </b-card-body>
                  </b-card>
              </b-col>
              <b-col sm="4" lg="4">
                  <b-card>
                  <template slot="header">
                      <h2 class="mt-2 custom-card-header-text">Top Advisors <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="The top 10 advisors ranked by engagement score." height="12" alt="tooltip" /></h2>
                      <router-link class="float-right mt-12 view-more" :to="memberLink" aria-label="View more Top Advisors">View more</router-link>
                  </template>
                      <b-card-body>
                          <v-client-table v-bind:data="topAdvisers" v-bind:columns="topAdvisersColumns" :options="topAdvisersOptions" id="dataTable" class="top_advisor">
                              <span slot="name" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
                                  {{props.row.name}}
                              </span>
                              <span slot="name" slot-scope="props" v-else-if="props.row.name">
                                  {{props.row.name}}
                              </span>
                          </v-client-table>
                      </b-card-body>
                  </b-card>
              </b-col>
              <b-col sm="4" lg="4">
                  <b-card>
                  <template slot="header">
                      <h2 class="mt-2 custom-card-header-text">Top Tags <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="The top 10 tags by count" alt="tooltip" height="12"/></h2>
                      <router-link class="float-right mt-12 view-more" :to="tagLink" aria-label="View more Top Tags">View more</router-link>
                  </template>
                      <b-card-body>
                          <v-client-table v-bind:data="topTags" v-bind:columns="topTagsColumns" :options="topTagsOptions" id="dataTable" class="top_tag">
                              <span slot="tag" slot-scope="props" class="display-link" @click="tagRequest(props.row.tag)" v-if="props.row.tag">
                                  {{props.row.tag}}
                              </span>
                              <span slot="tag" slot-scope="props" v-else>
                                  {{'N/A'}}
                              </span>
                          </v-client-table>
                      </b-card-body>
                  </b-card>
              </b-col>
          </b-row> -->
          <b-row v-if="selectedCommunity && 
             selectedCommunity !== 'all' && 
             communityLocation && 
             typeof communityLocation === 'object' &&
             communityLocation.latitude && 
             communityLocation.longitude && 
             !isNaN(communityLocation.latitude) && 
             !isNaN(communityLocation.longitude) && 
             communityLocation.latitude !== '' && 
             communityLocation.longitude !== '' && 
             communityLocation.latitude !== null && 
             communityLocation.longitude !== null && 
             communityLocation.latitude !== undefined && 
             communityLocation.longitude !== undefined">
    <b-col>
  <b-card>
    <template v-if="selectedCommunity !== 'all'">
      <CommunityLocationMap
        :latitude="communityLocation.latitude"
        :longitude="communityLocation.longitude"
        :city="communityLocation.city"
        :state="communityLocation.state"
        :country="communityLocation.country"
        :communityName="communityName"
      />
    </template>
  </b-card>
</b-col>
  </b-row>
  <!-- <b-row v-else>
    <b-col>
  <b-card>
    <template>
      <CommunitiesLocationMap
        :communities="allCommunityLocations"
      />
    </template>
  </b-card>
</b-col>
</b-row> -->
            <!-- <b-row>
<b-col sm="6" lg="6">
<b-card>
<template slot="header">
<h2 class="mt-2 custom-card-header-text">Request Engagement <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="Request Engagement shows you what percentage of advisors engage when a request is matched to them (30-day average)." alt="tooltip" height="12"/></h2>
<router-link class="float-right mt-12 view-more" :to="requestEngagementLink" aria-label="View more Request Engagement">View more</router-link>
</template>
<div>
<pie-example tabindex="0" class="pie-chart" id="request-pie-chart" aria-label="Request Engagement Pie chart" chartId="chart-doughnut-01" :bind="true" :chartData="piaChartData1" :options="piaChartOptions1" counter-data="0" :field="selected"></pie-example>
</div>
</b-card>
</b-col>
<b-col sm="6" lg="6">
<b-card>
<template slot="header">
<h2 class="mt-2 custom-card-header-text">Response Type <img src="img/tooltip.png" tabindex="0" v-b-tooltip.bottom title="How your advisors help by type of response (30-day average)." alt="tooltip" height="12"/></h2>
<router-link class="float-right mt-12 view-more" :to="responseTypeLink" aria-label="View more Response Type">View more</router-link>
</template>
<div>
<pie-example tabindex="0" class="pie-chart" id="response-pie-chart" aria-label="Response Type Pie chart" chartId="chart-doughnut-02" :bind="true" :chartData="piaChartData2" :options="piaChartOptions2" counter-data="0" :field="selected"></pie-example>
</div>
</b-card>
</b-col>
</b-row> -->
            <!-- <b-card no-body class="management-card-header">
<template>
<router-link to='/engagement/requests-overdue' class="router-link-color"><h4 v-b-tooltip.hover.right title="Requests that have not received an answer in 7+ days." class="mt-2 custom-card-header-text">Escalations</h4></router-link>
<router-link to='/engagement/requests-overdue' class="float-right mt-12 view-more" aria-label="View more Escalations">View more</router-link>
</template> -->
            <!-- <b-card-body>
<v-client-table v-bind:data="requests" v-bind:columns="columns" :options="requestOptions" id="dataTable" class="requests-overdue-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="subject" slot-scope="props">
{{props.row.subject ? props.row.subject : 'N/A'}}
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="action-width">
<ul class="list-inline">
<li class="list-inline-item">
<b-button v-b-tooltip.hover.bottom aria-label="View the request" class="notification-btn tab-focus" variant="dropbox" size="sm" @click="openRequestInNewTab(props.row.requestId)">
<span class="count" v-if="props.row.commentCount">{{props.row.commentCount}}</span>
<i class="icon-eye"></i>
</b-button>
</li>
</ul>
</span>
</v-client-table>
</b-card-body> -->
            <!-- </b-card>
<b-card no-body class="management-card-header">
<template>
<router-link to='/engagement/requests-approval' class="router-link-color"><h4 class="mt-2 custom-card-header-text">Request Approvals</h4></router-link>
<router-link to='/engagement/requests-approval' class="float-right mt-12 view-more" aria-label="View more Request Approvals">View more</router-link>
</template> -->
            <!-- <b-card-body>
<div class="toverflow-unset">
<v-client-table v-bind:data="requestApproval" v-bind:columns="requestApprovalColumns" :options="requestApprovalOptions" id="dataTable" class="request-approval-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="subject" slot-scope="props">
{{props.row.subject ? props.row.subject : 'N/A'}}
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="res-req-action-width">
<ul class="list-inline mb-0 text-center">
<li class="list-inline-item">
<b-button class="tab-focus" v-b-tooltip.hover.bottom aria-label="View the request" variant="dropbox" size="sm" @click="openRequestInNewTab(props.row.requestId)"><i class="icon-eye"></i></b-button>
</li>
<li class="list-inline-item" v-if="authUser.memberID || authUser.role =='SuperAdmin'">
<b-dropdown class="float-right" v-b-tooltip.hover.bottom title="Take action" variant="btn btn-dropbox btn-sm tab-focus" right>
<template slot="button-content">
<i class="icon-settings"></i>
</template>
<b-dropdown-item @click="approveRequest(props.row.requestId, 'approve', 'no')">Approve request</b-dropdown-item>
<b-dropdown-item @click="approveRequest(props.row.requestId, 'approve', 'yes')">Approve member</b-dropdown-item>
<!-- <b-dropdown-item @click="approveRequest(props.row.requestId, 'reject', 'coach')">Reject and coach</b-dropdown-item> --//comment this line
<b-dropdown-item @click="$router.push(`/engagement/requests-coach/${props.row.requestId}`)">Reject and coach</b-dropdown-item>
<b-dropdown-item @click="approveRequest(props.row.requestId, 'reject', 'no')">Reject and delete</b-dropdown-item>
</b-dropdown>
</li>
</ul>
</span>
</v-client-table>
</div>
</b-card-body> -->
            <!-- </b-card>
<b-card no-body class="management-card-header">
<template>
<router-link to='/engagement/responses-approval' class="router-link-color"><h4 class="mt-2 custom-card-header-text">Response Approvals</h4></router-link>
<router-link to='/engagement/responses-approval' class="float-right mt-12 view-more" aria-label="View more Response Approvals">View more</router-link>
</template> -->
            <!-- <b-card-body>
<div class="toverflow-unset">
<v-client-table v-bind:data="responseApproval" v-bind:columns="responseApprovalColumns" :options="responseApprovalOptions" id="dataTable" class="response-approval-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="advice" slot-scope="props">
<span v-b-tooltip.hover.bottom :title="props.row.advice" v-if="props.row.advice">{{getAdvice(props.row.advice)}}
</span>
<span v-else>N/A</span>
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="res-req-action-width">
<ul class="list-inline mb-0 text-center">
<li class="list-inline-item">
<b-button class="tab-focus" v-b-tooltip.hover.bottom title="View response" variant="dropbox" size="sm" @click="openResponseModal(props.row.advice)"><i class="icon-eye"></i></b-button>
</li>
<li class="list-inline-item" v-if="authUser.memberID || authUser.role =='SuperAdmin'">
<b-dropdown class="float-right" v-b-tooltip.hover.bottom title="Take action" variant="btn btn-dropbox btn-sm tab-focus" right>
<template slot="button-content">
<i class="icon-settings"></i>
</template>
<b-dropdown-item @click="approveResponse(props.row.requestId, props.row.giveId, 'approve', 'no')">Approve response</b-dropdown-item>
<b-dropdown-item @click="approveResponse(props.row.requestId, props.row.giveId, 'approve', 'yes')">Approve member</b-dropdown-item>
<!-- <b-dropdown-item @click="approveResponse(props.row.requestId, props.row.giveId, 'reject', 'coach')">Reject and coach</b-dropdown-item> --//comment this line
<b-dropdown-item @click="$router.push(`/engagement/requests-response-coach/${props.row.requestId}/${props.row.giveId}`)">Reject and coach</b-dropdown-item>
<b-dropdown-item @click="approveResponse(props.row.requestId, props.row.giveId, 'reject', 'no')">Reject and delete</b-dropdown-item>
</b-dropdown>
</li>
</ul>
</span>
</v-client-table>
</div>
</b-card-body> -->
            <!-- <b-modal id="response-modal" class="response-modal" size="lg" ok-title="Close" v-model="responseModal" @ok="responseModal = false">
{{giveAdvice}}
</b-modal>
</b-card> -->
            <!-- Incomplete Requests card start -->
            <!-- <b-card no-body class="management-card-header">
<template>
<router-link to='/engagement/incomplete-requests' class="router-link-color"><h4 class="mt-2 custom-card-header-text">Incomplete Requests</h4></router-link>
<router-link to='/engagement/incomplete-requests' class="float-right mt-12 view-more" aria-label="View more Incomplete Requests">View more</router-link>
</template> -->
            <!-- <b-card-body>
<v-client-table v-bind:data="incompletedRequests" v-bind:columns="incompletedRequestColumns" :options="incompletedRequestOptions" id="dataTable" class="requests-overdue-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="subject" slot-scope="props">
{{props.row.subject ? props.row.subject : 'N/A'}}
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="action-width">
<ul class="list-inline">
<li class="list-inline-item">
<b-button v-b-tooltip.hover.bottom aria-label="View the request" class="notification-btn" variant="dropbox tab-focus" size="sm" @click="openRequestInNewTab(props.row.requestId,'incomplete')">
<span class="count" v-if="props.row.commentCount">{{props.row.commentCount}}</span>
<i class="icon-eye"></i>
</b-button>
</li>
</ul>
</span>
</v-client-table>
</b-card-body> -->
            <!-- </b-card>
Incomplete Requests card end
Rejected Request card start
<b-card no-body class="management-card-header">
<template>
<router-link to='/engagement/rejected-requests' class="router-link-color"><h4 class="mt-2 custom-card-header-text">Rejected Requests</h4></router-link>
<router-link to='/engagement/rejected-requests' class="float-right mt-12 view-more" aria-label="View more Rejected Requests">View more</router-link>
</template> -->
            <!-- <b-card-body>
<div class="toverflow-unset">
<v-client-table v-bind:data="requestReject" v-bind:columns="requestRejectColumns" :options="requestRejectOptions" id="dataTable" class="request-approval-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="subject" slot-scope="props">
{{props.row.subject ? props.row.subject : 'N/A'}}
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="res-req-action-width">
<ul class="list-inline mb-0 text-center">
<li class="list-inline-item">
<b-button v-b-tooltip.hover.bottom aria-label="View the request" variant="dropbox tab-focus" size="sm" @click="openRequestInNewTab(props.row.requestId)"><i class="icon-eye"></i></b-button>
</li>
<li class="list-inline-item" v-if="authUser.memberID || authUser.role =='SuperAdmin'">
<b-dropdown class="float-right" v-b-tooltip.hover.bottom title="Take action" variant="btn btn-dropbox btn-sm tab-focus" right>
<template slot="button-content">
<i class="icon-settings"></i>
</template>
<b-dropdown-item  v-if="setStatus(props.row.status) == 'Closed' || setStatus(props.row.status) == 'Rejected'" @click="reOpenRequest(props.row.requestId)">Reopen the request</b-dropdown-item>
</b-dropdown>
</li>
</ul>
</span>
</v-client-table>
</div>
</b-card-body> -->
            <!-- </b-card> -->
            <!-- Rejected Request card end -->
            <!-- Rejected Response card start -->
            <!-- <b-card no-body class="management-card-header">
<template   >
<router-link to='/engagement/rejected-responses' class="router-link-color"><h4 class="mt-2 custom-card-header-text">Rejected Responses</h4></router-link>
<router-link to='/engagement/rejected-responses' class="float-right mt-12 view-more" aria-label="View more Rejected Responses">View more</router-link>
</template> -->
            <!-- <b-card-body>
<div class="toverflow-unset">
<v-client-table v-bind:data="responseReject" v-bind:columns="responseRejectColumns" :options="responseRejectOptions" id="dataTable" class="response-approval-table">
<span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
{{props.row.member}}
</span>
<span slot="member" slot-scope="props" v-else-if = "props.row.member">
{{props.row.member}}
</span>
<span slot="response_Action" slot-scope="props">
<span v-b-tooltip.hover.bottom :title="showResponse(props.row)" v-if="props.row.response_Action">{{getAdvice(props.row.response_Action)}}
</span>
<span v-else>N/A</span>
</span>
<span slot="date" slot-scope="props" v-if="props.row.date">
{{ props.row.date | momentDate }}
</span>
<span slot="date" v-else>N/A</span>
<span slot="action" slot-scope="props" class="res-req-action-width">
<ul class="list-inline mb-0 text-center">
<li class="list-inline-item">
<b-button v-b-tooltip.hover.bottom title="View response" variant="dropbox tab-focus" size="sm" @click="openResponseModal(showResponse(props.row))"><i class="icon-eye"></i></b-button>
</li>
</ul>
</span>
</v-client-table>
</div>
</b-card-body> -->
            <b-modal id="response-modal" class="response-modal" size="lg" ok-title="Close" v-model="responseModal"
                @ok="responseModal = false">
                {{ giveAdvice }}
            </b-modal>
            <!-- Rejected Response card end -->
        </div>
        <div class="pie-content">
            <div class="pie-chart-table1" tabindex="0" aria-label="Pie Chart 1"></div>
            <table class="request-table">
                <thead>
                    <tr>
                        <th scope="col">Advisor</th>
                        <th scope="col">Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(count, index) in dataPieChart1" :key="index">
                        <td scope="row">{{ piaChartData1.labels[index] }}</td>
                        <td scope="row">{{ count }}</td>
                    </tr>
                </tbody>
            </table>
            <div id="announcement" aria-live="assertive"></div>
        </div>
        <div class="pie-content">
            <div class="pie-chart-table2 pie-content-table" tabindex="0" aria-label="Pie Chart 2"></div>
            <table class="response-table">
                <thead>
                    <tr>
                        <th scope="col">Advisor</th>
                        <th scope="col">Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(count, index) in dataPieChart2" :key="index">
                        <td scope="row">{{ piaChartData2.labels[index] }}</td>
                        <td scope="row">{{ count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  
  <script>
  import WidgetsCustomSkeleton from './dashboard/WidgetsCustomSkeleton'
  import AnalyticsLineChartExample from './dashboard/AnalyticsLineChartExample'
  import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
  import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
  import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
  import CardBarChartExample from './dashboard/CardBarChartExample'
  import { setRequestStatus } from '@/assets/js/set-status';
  import { toDayParam, pickedDayToUtc, lastNDaysStart } from '@/assets/js/common';
  import VueNotifications from 'vue-notifications';
  // import MainChartExample from './dashboard/MainChartExample'
  import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
  import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
  import { random } from '@/shared/utils'
  import PieExample from './dashboard/PieExample'
  import EventBus from '../assets/js/EventBus';
  import CommunityLocationMap from './dashboard/CommunityLocationMap';
  import CommunitiesLocationMap from './dashboard/CommunitiesLocationMap'
  import WordCloud from '../components/WordCloud.vue'
  export default {
      name: 'dashboard',
      components: {
          AnalyticsLineChartExample,
          CardLine1ChartExample,
          CardLine2ChartExample,
          CardLine3ChartExample,
          CardBarChartExample,
          // MainChartExample,
          PieExample,
          WordCloud,
          WidgetsCustomSkeleton,
          CommunityLocationMap,
          CommunitiesLocationMap
      },
      data() {
          return {
              isWidgetsLoading: false,
                            requestsCount: 0,
                            wordList: [],
                            responsesCount: 0,
              membersCount: 0,
              satisfactionsAvg: 0.0,
              profileUpdates: 0,
              visitorsCount: 0,
              alumniContacted:0,
              emailOpen:0,
              clickCount:0,
              token: '',
              selectedCommunity: null,
              selectedTimeframe: 'monthly',
              selectedCircle: null,
              circleShortName: null,
              selectedDates: {startDate: null, endDate: null},
              // True when the header picker is on "Custom dates" (local calendar days).
              isCustomRange: false,
              selected: 'month',
              chartScale: 10,
              chartData: {
                  labels: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                  datasets: [{
                      backgroundColor: hexToRgba('#20a8d8', 10),
                      borderColor: '#20a8d8',
                      pointHoverBackgroundColor: '#fff',
                      borderWidth: 2,
                      data: []
                  }]
              },
              chartOptions: {
                  tooltips: {
                      enabled: false,
                      custom: CustomTooltips,
                      intersect: true,
                      mode: 'index',
                      position: 'nearest',
                      callbacks: {
                          labelColor: function (tooltipItem, chart) {
                              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
                          }
                      }
                  },
                  maintainAspectRatio: false,
                  legend: {
                      display: false
                  },
                  scales: {
                      xAxes: [{
                          ticks: {
                              fontColor: "#fff"
                          },
                          gridLines: {
                              drawOnChartArea: false
                          }
                      }],
                      yAxes: [{
                          ticks: {
                              beginAtZero: true,
                              maxTicksLimit: 5,
                              stepSize: Math.ceil(10 / 5),
                              max: 10,
                              fontColor: "#fff"
                          },
                          gridLines: {
                              display: true
                          }
                      }]
                  },
                  elements: {
                      point: {
                          radius: 0,
                          hitRadius: 10,
                          hoverRadius: 4,
                          hoverBorderWidth: 3
                      }
                  }
              },
              analyticsChartDatasets: [],
              analyticsChartLabels: [],
              requestEngagementLink: '',
              responseTypeLink: '',
              piaChartData1: {
                  labels: ['Request Email', '1st Reminder', '2nd Reminder'],
                  datasets: [
                      {
                          borderColor: '#A9A9A9',
                          backgroundColor: [
                              '#c69500',
                              '#2eadd3',
                              '#187da0'
                          ],
                          data: [],
                          borderWidth: '0'
                      }
                  ]
              },
              piaChartOptions1: {
                  tooltips: {
                      callbacks: {
                          title: function(tooltipItem, data) {
                              return data['labels'][tooltipItem[0]['index']];
                          },
                          label: function(tooltipItem, data) {
                              let sum = data['datasets'][0].data.reduce(function(a, b){
                                  return a + b;
                              }, 0);
                              let dataset = data['datasets'][0];
                              let percent = Math.round((dataset['data'][tooltipItem['index']] / sum) * 100)
                              return data['datasets'][0]['data'][tooltipItem['index']] + ' / ' + percent + '%';
                          }
                      },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: {
                      display: true,
                      borderWidth: '0',
                      labels: {
                          fontColor: "#fff",
                      }
                  }
              },
              piaChartData2: {
                  labels: ['Advice', 'Call', 'Meeting'],
                  datasets: [
                      {
                          borderColor: '#A9A9A9',
                          backgroundColor: [
                              '#c69500',
                              '#2eadd3',
                              '#187da0'
                          ],
                          data: [],
                          borderWidth: '0',
                      }
                  ]
              },
              piaChartOptions2: {
                  tooltips: {
                      callbacks: {
                          title: function(tooltipItem, data) {
                              return data['labels'][tooltipItem[0]['index']];
                          },
                          label: function(tooltipItem, data) {
                              let sum = data['datasets'][0].data.reduce(function(a, b){
                                  return a + b;
                              }, 0);
                              let dataset = data['datasets'][0];
                              let percent = Math.round((dataset['data'][tooltipItem['index']] / sum) * 100)
                              return data['datasets'][0]['data'][tooltipItem['index']] + ' / ' + percent + '%';
                          }
                      },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: {
                      display: true,
                      borderWidth: '0',
                      labels: {
                          fontColor: "#fff",
                      }
                  }
              },
              response: [],
              requestLink: '',
              responseLink: '',
              feedbackLink: '',
              memberLink: '',
              tagLink: '',
              requests: [],
              columns: ['member', 'community', 'circle', 'date', 'subject', 'Sent','Opened','Accepted','Declined', 'Referred', 'Feedback', 'action'],
              requestOptions: {
                  headings: {
                      Sent: 'S',
                      Opened: 'O',
                      Accepted: 'A',
                      Declined: 'D',
                      Referred: 'R',
                      Feedback: 'F',
                  },
                  sortable: ['member', 'community', 'circle', 'date', 'subject', 'Sent','Opened','Accepted','Declined', 'Referred','Feedback'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' }
              },
              incompletedRequests: [],
              incompletedRequestColumns: ['member', 'community', 'circle', 'date', 'subject', 'Sent','Opened','Accepted','Declined', 'Referred', 'Feedback', 'action'],
              incompletedRequestOptions: {
                  headings: {
                      Sent: 'S',
                      Opened: 'O',
                      Accepted: 'A',
                      Declined: 'D',
                      Referred: 'R',
                      Feedback: 'F',
                  },
                  sortable: ['member', 'community', 'circle', 'date', 'subject', 'Sent','Opened','Accepted','Declined', 'Referred','Feedback'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' }
              },
              requestApproval: [],
              requestApprovalColumns: ['date', 'member', 'circle', 'subject', 'action'],
              requestApprovalOptions: {
                  headings: {
                      member: 'Name'
                  },
                  sortable: ['date', 'member', 'subject'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              },
              responseApproval: [],
              responseApprovalColumns: ['date', 'member', 'circle', 'advice', 'action']   ,
              responseApprovalOptions: {
                  headings: {
                      member: 'Name'
                  },
                  sortable: ['date', 'member', 'circle', 'advice'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              },
              authUser: {},
              responseModal: false,
              giveAdvice: '',
              emailOpen: 0,
              emailOpenPercentage: 0.0,
              emailClickPercentage: 0.0,
              engagementRate: 0,
              firstResponse: 0,
              responsePerRequest: 0,
              satisfactionData: 0,
              profileUpdate: 0,
              responsePerRequestPercentage : 0,
              satisfactionDataPercentage: 0,
              alumniEngaged: 0,
              prospectsEngaged: 0,
              assignedProspectsEngaged: 0,
              activatedAlumni: 'N/A',
            //   activatedProspects: 0,
              donorAlerts: 0,
              answeredQuestionsPercent: 0,
              emailOpenLink: '',
              engagementRateLink: '',
              firstResponseLink: '',
              responsePerRequestLink: '',
              satisfactionLink: '',
              profileUpdateLink: '',
              communityName: '',
              communityLocation: {},
              topMembers: [],
              topMembersColumns: ['name', 'engagementPoints'],
              topMembersOptions: {
                  headings: {
                      engagementPoints: 'Engagement',
                      name: "Member"
                  },
                  sortable: ['name', 'engagementPoints'],
                  filterable: false
              },
              topAdvisers: [],
              topAdvisersColumns: ['name', 'engagementPoints'],
              topAdvisersOptions: {
                  headings: {
                      engagementPoints: 'Engagement',
                      name: "Member"
                  },
                  sortable: ['name', 'engagementPoints'],
                  filterable: false
              },
              topTags: [],
              topTagsColumns: ['tag', 'count'],
              topTagsOptions: {
                  sortable: ['tag', 'count'],
                  filterable: false
              },
              requestReject: [],
              requestRejectColumns: ['date', 'member', 'circle', 'subject', 'action'],
              requestRejectOptions: {
                  headings: {
                      member: 'Name'
                  },
                  sortable: ['date', 'member', 'circle', 'subject'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              },
              responseReject: [],
              responseRejectColumns: ['date', 'member', 'circle','response_Action', 'action']   ,
              responseRejectOptions: {
                  headings: {
                      member: 'Name'
                  },
                  sortable: ['date', 'member', 'circle', 'response_Action'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              },
              dataPieChart1: [0, 0, 0],
              dataPieChart2: [0, 0, 0],
              allCommunityLocations: [],
          }
      },
      computed: {
          calculatedAvgResponse() {
              const req = Number(this.requestsCount) || 0;
              const res = Number(this.responsesCount) || 0;
              if (req === 0) return '0.0';
              return (res / req).toFixed(1);
          }
      },
      watch: {
          "$route": function(newRoute) {
              // With keep-alive, this watcher fires even when dashboard is cached but inactive
              if (!this._isActive) return;
              // Only react if navigating between dashboard subroutes
              const isDashboardRoute = newRoute.path === '/dashboard' || newRoute.path.startsWith('/dashboard/communities/');
              if (isDashboardRoute) {
                  this.loadData();
              }
          },
          selectedCommunity: {
            immediate: true,
            async handler(newValue) {
                if(!this.token) {
                    this.token = localStorage.getItem('token');
                }if(newValue === 'all') {
                    await this.fetchAllCommunityLocations();
                }
                if(this.token){
                    this.topRequestTags();
                }
            }
        },
        // "selected": "loadEngagementChart"
        //     selectedCommunity: 'loadData',
        //     selectedCircle: 'loadData',
        //     selectedDates: {
        //         handler: 'loadData',
        //         deep: true
    },
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    async created() {
        this._lastLoadTimestamp = null;
        this._isActive = true;

        const user = localStorage.getItem('authUser');
        if (user) {
            this.authUser = JSON.parse(user);
        }

        await this.fetchAllCommunityLocations();

        // Register EventBus listeners ONCE (created() only runs once with keep-alive)
        EventBus.$on('communityChanged', async (community) => {
            this.selectedCommunity = community;
            await this.fetchCommunityName();
            await this.fetchCommunityLocation();
            if (this._isActive) {
                this.loadData();
            }
        });
        EventBus.$on('circleChanged', async (res) => {
            this.selectedCircle = res.circle;
            this.selectedCommunity = res.community;
            this.circleShortName = res.circleShortName;
            await this.fetchCommunityName();
            await this.fetchCommunityLocation();
            if (this._isActive) {
                this.loadData();
            }
        });
        EventBus.$on('dateChanged', (dates) => {
            this.selectedDates.startDate = dates.startDate;
            this.selectedDates.endDate = dates.endDate;
            this.isCustomRange = dates.selectedValue === 'custom';
            this.selectedTimeframe = dates.selectedValue;
            if (this.selectedTimeframe === 'last-7') {
                this.selectedTimeframe = 'weekly';
            } else if (this.selectedTimeframe === 'last-30') {
                this.selectedTimeframe = 'monthly';
            } else if (this.selectedTimeframe === 'ytd') {
                this.selectedTimeframe = 'ytd';
            } else if (this.selectedTimeframe === null) {
                this.selectedTimeframe = 'all';
            } else if (this.selectedTimeframe === 'custom') {
                this.selectedTimeframe = 'custom';
            }
            if (this._isActive) {
                this.loadData();
            }
        });
    },
    activated() {
        // Called on EVERY activation: first mount + every return from another page
        this._isActive = true;
        const STALE_THRESHOLD_MS = 30 * 60 * 1000; // 30 minutes
        const now = Date.now();
        const isStale = !this._lastLoadTimestamp || (now - this._lastLoadTimestamp) > STALE_THRESHOLD_MS;

        if (isStale) {
            this.loadData();
        }
    },
    deactivated() {
        this._isActive = false;
    },
    beforeDestroy() {
        EventBus.$off('communityChanged');
        EventBus.$off('circleChanged');
        EventBus.$off('dateChanged');
    },
    methods: {
        async loadData() {
            // only the latest loadData() call assigns results
            this._loadDataVersion = (this._loadDataVersion || 0) + 1;
            const currentVersion = this._loadDataVersion;

            this.isWidgetsLoading = true;
            this.token = localStorage.getItem('token');

            // Reset widgets so old values don't flash during load
            this.visitorsCount = 0;
            this.requestsCount = 0;
            this.responsesCount = 0;
            this.alumniContacted = 0;
            this.alumniEngaged = 0;
            this.prospectsEngaged = 0;
            this.assignedProspectsEngaged = 0;
            this.donorAlerts = 0;
            this.profileUpdates = 0;
            this.answeredQuestionsPercent = 0;
            this.satisfactionsAvg = 0.0;
            this.clickCount = 0;
            this.emailOpen = 0;
            this.emailOpenPercentage = 0.0;
            this.emailClickPercentage = 0.0;
            this.engagementRate = 0;

            // Check for saved community preference
            if (!this.selectedCommunity && !this.$route.params.community_id) {
                const savedOption = localStorage.getItem('user_modal_option');
                if (savedOption) {
                    this.selectedCommunity = savedOption;
                } else {
                    console.log("No community selected, skipping dashboard data load.");
                    this.isWidgetsLoading = false;
                    return;
                }
            }

            const baseUrl = process.env.VUE_APP_API_BASE_URL;

            // Prepare all API endpoints
            const endpoints = {
                requestCount: `${baseUrl}/dashboard/request/count`,
                answeredCount: `${baseUrl}/dashboard/request/answered-count`,
                responseCount: `${baseUrl}/dashboard/response/count`,
                clickCount: `${baseUrl}/dashboard/click_count`,
                visitorsCount: `${baseUrl}/dashboard/visitors-count`,
                sixMonthsData: `${baseUrl}/dashboard/six-months-data`,
                // activatedAlumni: `${baseUrl}/dashboard/activated_alumni`,
                // activatedProspects: `${baseUrl}/dashboard/activated_prospects`,
                assignedProspectsEngaged: `${baseUrl}/dashboard/assigned_prospects_engaged`,
                donorAlerts: `${baseUrl}/dashboard/donor_alerts`,
                prospectsEngaged: `${baseUrl}/dashboard/prospects_engaged`,
                alumniEngaged: `${baseUrl}/dashboard/alumnis_engaged`,
                alumniContacted: `${baseUrl}/dashboard/alumni_contacted`,
                profileUpdates: `${baseUrl}/dashboard/update_profile`,
                satisfactionAvg: `${baseUrl}/dashboard/satisfaction_avg`
            };

            // Prepare request parameters
            const communityId = this.$route.params.community_id || (this.selectedCommunity !== 'all' ? this.selectedCommunity : '');
            const circle = this.selectedCircle !== 'all' && this.selectedCircle !== 'null' ? this.selectedCircle : '';
            let rangeStart = this.selectedDates.startDate ? new Date(this.selectedDates.startDate) : null;
            let rangeEnd = this.selectedDates.endDate ? new Date(this.selectedDates.endDate) : null;
            // If no custom dates selected, default to past 30 days to match other widget queries.
            // Day-boundary snapping (start/end of day, in one shared time zone) is handled
            // server-side by resolveDateRange() (dateRange.helper.js) — the backend owns
            // "today," not the browser, so admins in different time zones always agree.
            if (!rangeStart && !rangeEnd) {
                rangeStart = lastNDaysStart(30);
                rangeEnd = new Date();
            }
            // Bare "YYYY-MM-DD" days (see dayParam) — same params the Stream and the
            // Reports CSV send, so all three resolve to the identical window.
            const startDate = this.dayParam(rangeStart);
            const endDate = this.dayParam(rangeEnd);
            // Every widget count fetched below (in the Promise.allSettled batch) uses
            // this exact startDate/endDate.
            this._widgetDateRange = { startDate, endDate };
            // GA4 also takes plain YYYY-MM-DD.
            const gaStartDate = startDate;
            const gaEndDate = endDate;
            const communityName = this.communityName;
            const circleShortName = this.circleShortName;
            const timeframe = this.selectedTimeframe || 'monthly';

            // Common request config
            const config = {
                headers: { 'x-access-token': this.token }
            };

            try {
                // Handle different cases for community selection
                if (communityId || this.selectedCommunity) {

                    // Setup API requests with appropriate parameters
                    const sixMonthsDataUrl = `${endpoints.sixMonthsData}?community=${communityName}&circle=${circle}`;
                    const visitorsUrl = `${endpoints.visitorsCount}?timeframe=${timeframe}&community=${communityId}&circle=${circle}&startDate=${gaStartDate}&endDate=${gaEndDate}`;

                    const isValidObjectId = (id) => /^[0-9a-fA-F]{24}$/.test(id);
                    const circleId = (!this.selectedCircle || this.selectedCircle === 'all' || !isValidObjectId(this.selectedCircle)) ? '' : this.selectedCircle;

                    // Common params for most requests
                    const params = {
                        community: communityId,
                        circle: circleShortName,
                        startDate,
                        endDate
                    };

                    // Execute requests in parallel - use allSettled so individual failures
                    // don't prevent other widgets from displaying their data
                    const settled = await Promise.allSettled([
                        this.axios.get(visitorsUrl, config),
                        this.axios.get(endpoints.requestCount, { ...config, params: { ...params, circle: circleShortName } }),
                        this.axios.get(endpoints.answeredCount, { ...config, params: { ...params, circle: circleShortName } }),
                        this.axios.get(endpoints.responseCount, { ...config, params: { ...params, circle: circleShortName } }),
                        this.axios.get(endpoints.alumniContacted, { ...config, params: { ...params, circle: circleShortName } }),
                        this.axios.get(endpoints.assignedProspectsEngaged, { ...config, params }),
                        this.axios.get(endpoints.alumniEngaged, { ...config, params }),
                        this.axios.get(endpoints.prospectsEngaged, { ...config, params }),
                        this.axios.get(endpoints.donorAlerts, { ...config, params }),
                        this.axios.get(endpoints.profileUpdates, { ...config, params }),
                        this.axios.get(endpoints.satisfactionAvg, {
                            ...config,
                            params: {
                                ...params,
                                community_id: communityId,
                                // circleId is the circle's _id (see isValidObjectId above) — the
                                // backend's sourceparam match (getFeedbackQuery) compares against
                                // the short name (e.g. "wgu_potential_students").
                                circle: circleShortName,
                                dashboard: true
                            }
                        })
                    ]);

                    if (this._loadDataVersion !== currentVersion) return;

                    // Extract fulfilled values, null if rejected
                    const val = (i) => settled[i].status === 'fulfilled' ? settled[i].value : null;
                    const visitorsResponse = val(0);
                    const requestsResponse = val(1);
                    const answeredCountResponse = val(2);
                    const responseCountResponse = val(3);
                    const alumniContactedResponse = val(4);
                    const assignedProspectsEngagedResponse = val(5);
                    const alumniEngagedResponse = val(6);
                    const prospectsEngagedResponse = val(7);
                    const donorAlertsResponse = val(8);
                    const profileUpdatesResponse = val(9);
                    const satisfactionAvgResponse = val(10);

                    // Log any failed requests for debugging
                    settled.forEach((r, i) => {
                        if (r.status === 'rejected') console.warn(`Dashboard widget request [${i}] failed:`, r.reason);
                    });

                    // Process responses (six months data fetched separately)
                    try {
                        const sixMonthsResponse = await this.axios.get(sixMonthsDataUrl, config);
                        if (this._loadDataVersion !== currentVersion) return;
                        this.sixMonthsData = sixMonthsResponse.data;
                        this.analyticsChartDatasets = sixMonthsResponse.data.dataset;
                        this.analyticsChartLabels = sixMonthsResponse.data.monthLabels;
                    } catch (e) {
                        console.warn('Failed to load six months data:', e);
                    }

                    if (this._loadDataVersion !== currentVersion) return;
                    this.visitorsCount = (visitorsResponse && visitorsResponse.data.visitorCount) || 0;
                    this.requestsCount = (requestsResponse && requestsResponse.data) || 0;
                    this.responsesCount = (responseCountResponse && responseCountResponse.data) || 0;

                    // Calculate answered questions percentage
                    const answeredCount = (answeredCountResponse && answeredCountResponse.data) || 0;
                    if (this.requestsCount > 0) {
                        this.answeredQuestionsPercent = Math.round((answeredCount / this.requestsCount) * 100);
                    } else {
                        this.answeredQuestionsPercent = 0;
                    }

                    this.alumniContacted = (alumniContactedResponse && alumniContactedResponse.data.alumniContactedCount) || 0;
                    this.activatedAlumni = 'N/A';
                    this.assignedProspectsEngaged = (assignedProspectsEngagedResponse && assignedProspectsEngagedResponse.data.count) || 0;
                    this.alumniEngaged = (alumniEngagedResponse && alumniEngagedResponse.data.count) || 0;
                    this.prospectsEngaged = (prospectsEngagedResponse && prospectsEngagedResponse.data.count) || 0;
                    this.donorAlerts = (donorAlertsResponse && donorAlertsResponse.data.count) || 0;
                    this.profileUpdates = (profileUpdatesResponse && profileUpdatesResponse.data.count) || 0;
                    this.satisfactionsAvg = (satisfactionAvgResponse && satisfactionAvgResponse.data) || 0.0;


                    // Setup links
                    this.requestLink = { name: 'CommunityRequests', params: { community_id: communityId } };
                    this.responseLink = { name: 'CommunityResponses', params: { community_id: communityId } };
                    this.feedbackLink = { name: 'CommunityFeedback', params: { community_id: communityId } };
                    this.memberLink = { name: 'CommunityMembers', params: { community_id: communityId } };
                    this.emailOpenLink = `/analytics/email_open/?community_id=${communityId}`;
                    this.engagementRateLink = `/analytics/engagement_rate/?community_id=${communityId}`;
                    // this.firstResponseLink = `/analytics/first_response/?community_id=${communityId}`;
                    // this.responsePerRequestLink = `/analytics/response_per_request/?community_id=${communityId}`;
                    // this.satisfactionLink = `/analytics/satisfaction/?community_id=${communityId}`;
                    // this.profileUpdateLink = `/analytics/profile_update/?community_id=${communityId}`;
                    this.tagLink = `/engagement/tags_by_occurrence/?community_id=${communityId}`;
                    this.requestEngagementLink = `/engagement/request-engagement/?community_id=${communityId}`;
                    this.responseTypeLink = `/engagement/response-type/?community_id=${communityId}`;

                } else {
                    // Handle case when no community is selected or "all" is selected
                    if (this.selectedCommunity && this.selectedCommunity !== 'all') {
                        this.tagLink = `/engagement/tags_by_occurrence/?community_id=${this.selectedCommunity}`;
                        this.memberLink = { name: 'CommunityMembers', params: { community_id: this.selectedCommunity } };
                    } else {
                        this.tagLink = '/engagement/tags_by_occurrence';
                        this.memberLink = '/engagement/members';
                    }

                    const visitorsUrl = `${endpoints.visitorsCount}?timeframe=${timeframe}&startDate=${gaStartDate}&endDate=${gaEndDate}`;

                    // Get six months data if a community is selected
                    if (this.selectedCommunity !== 'all') {
                        const sixMonthsResponse = await this.axios.get(endpoints.sixMonthsData, config);
                        if (this._loadDataVersion !== currentVersion) return;
                        this.sixMonthsData = sixMonthsResponse.data;
                        this.analyticsChartDatasets = sixMonthsResponse.data.dataset;
                        this.analyticsChartLabels = sixMonthsResponse.data.monthLabels;
                        console.log("analyticsChartDatasets", this.analyticsChartDatasets);
                        console.log("analyticsChartLabels", this.analyticsChartLabels);
                    }

                    // Get visitors count
                    const visitorsResponse = await this.axios.get(visitorsUrl, config);
                    if (this._loadDataVersion !== currentVersion) return;
                    this.visitorsCount = visitorsResponse.data.visitorCount || 0;
                    console.log("visitorsCount", this.visitorsCount);

                    // Prepare params based on date selection
                    const hasDateRange = startDate && endDate;
                    const params = hasDateRange ? { startDate, endDate } : {};

                    console.log(hasDateRange ? "if is running" : "else is running");

                    // Execute requests in parallel
                    const isValidObjectId = (id) => /^[0-9a-fA-F]{24}$/.test(id);
                    const circleId = (!this.selectedCircle || this.selectedCircle === 'all' || !isValidObjectId(this.selectedCircle)) ? '' : this.selectedCircle;

                    // Execute requests in parallel - use allSettled so individual failures
                    // don't prevent other widgets from displaying their data
                    const settled2 = await Promise.allSettled([
                        this.axios.get(endpoints.requestCount, { ...config, params }),
                        this.axios.get(endpoints.answeredCount, { ...config, params }),
                        this.axios.get(endpoints.responseCount, { ...config, params }),
                        this.axios.get(endpoints.alumniContacted, { ...config, params }),
                        this.axios.get(endpoints.assignedProspectsEngaged, { ...config, params }),
                        this.axios.get(endpoints.alumniEngaged, { ...config, params }),
                        this.axios.get(endpoints.prospectsEngaged, { ...config, params }),
                        this.axios.get(endpoints.donorAlerts, { ...config, params }),
                        this.axios.get(endpoints.profileUpdates, { ...config, params }),
                        this.axios.get(endpoints.satisfactionAvg, {
                            ...config,
                            params: {
                                ...params,
                                community_id: communityId,
                                // See the same fix/comment on the other satisfactionAvg call above —
                                // circleId is a circle _id, not the short name sourceparam matches.
                                circle: circleShortName,
                                dashboard: true
                            }
                        })
                    ]);

                    if (this._loadDataVersion !== currentVersion) return;

                    // Extract fulfilled values, null if rejected
                    const val2 = (i) => settled2[i].status === 'fulfilled' ? settled2[i].value : null;
                    const requestsResponse = val2(0);
                    const answeredCountResponse = val2(1);
                    const responseCountResponse = val2(2);
                    const alumniContactedResponse = val2(3);
                    const assignedProspectsEngagedResponse = val2(4);
                    const alumniEngagedResponse = val2(5);
                    const prospectsEngagedResponse = val2(6);
                    const donorAlertsResponse = val2(7);
                    const profileUpdatesResponse = val2(8);
                    const satisfactionAvgResponse = val2(9);

                    // Log any failed requests for debugging
                    settled2.forEach((r, i) => {
                        if (r.status === 'rejected') console.warn(`Dashboard widget request [${i}] failed:`, r.reason);
                    });

                    // Process responses
                    this.requestsCount = (requestsResponse && requestsResponse.data) || 0;
                    this.responsesCount = (responseCountResponse && responseCountResponse.data) || 0;

                    // Calculate answered questions percentage
                    const answeredCount = (answeredCountResponse && answeredCountResponse.data) || 0;
                    if (this.requestsCount > 0) {
                        this.answeredQuestionsPercent = Math.round((answeredCount / this.requestsCount) * 100);
                    } else {
                        this.answeredQuestionsPercent = 0;
                    }

                    this.alumniContacted = (alumniContactedResponse && alumniContactedResponse.data.alumniContactedCount) || 0;
                    this.activatedAlumni = 'N/A';
                    this.assignedProspectsEngaged = (assignedProspectsEngagedResponse && assignedProspectsEngagedResponse.data.count) || 0;
                    this.alumniEngaged = (alumniEngagedResponse && alumniEngagedResponse.data.count) || 0;
                    this.prospectsEngaged = (prospectsEngagedResponse && prospectsEngagedResponse.data.count) || 0;
                    this.donorAlerts = (donorAlertsResponse && donorAlertsResponse.data.count) || 0;
                    this.profileUpdates = (profileUpdatesResponse && profileUpdatesResponse.data.count) || 0;
                    this.satisfactionsAvg = (satisfactionAvgResponse && satisfactionAvgResponse.data) || 0.0;


      // Setup links
      this.requestLink = '/engagement/requests';
      this.responseLink = '/engagement/responses';
      this.feedbackLink = '/engagement/feedback';
      this.emailOpenLink = `/analytics/email_open`;
      this.engagementRateLink = `/analytics/engagement_rate`;
      this.requestEngagementLink = `/engagement/request-engagement`;
      this.responseTypeLink = `/engagement/response-type`;
    }
    
    if (this._loadDataVersion !== currentVersion) return;
    this.getWidgetData(currentVersion);
    this.topMemberAdvisor();
    //this.topRequestTags();
    this.$helpers.setTabindexOnTableCells();

  } catch (error) {
    console.error("Error loading dashboard data:", error);
  } finally {
    if (this._loadDataVersion === currentVersion) {
      this.isWidgetsLoading = false;
      this._lastLoadTimestamp = Date.now();
    }
  }
},
      reOpenRequest: async function (askId) {
          await this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/request/reopen`, {askId: askId},{ headers: {'x-access-token': this.token}}).then(response => {
              this.loadData();
          });
      },
      // engagementChart: async function() {
      //     let labels = [];
      //     let data = [];
      //     let chartScale = 0;
      //     await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/engagement-point/?date=${this.selected}&community_id=${this.$route.params.community_id ? this.$route.params.community_id: ''}`, { headers: {'x-access-token': this.token}}).then(response => {
      //         if (this.selected == 'month') {
      //             // response.data = this.$lodash.orderBy(response.data, ['date'], ['asc']);
      //             // sort date in desc order (old to new)
      //             response.data = this.$lodash.orderBy(response.data, function(data) {return new Date(data.date);});
      //         }
      //         for (let i = 0; i < response.data.length; i++) {
      //             labels.push(response.data[i].date);
      //             data.push(response.data[i].points);
      //             if (response.data[i].points > chartScale) {
      //                 chartScale = response.data[i].points;
      //             }
      //         }
      //         this.chartScale = chartScale;
      //         this.chartOptions.scales.yAxes[0].ticks.max = chartScale;
      //         if (this.selected == 'year') {
      //             labels.reverse();
      //             data.reverse();
      //         }
      //         this.chartData.labels = labels;
      //         this.chartData.datasets[0].data = data;
      //     });
      // },
      // loadEngagementChart: async function() {
      //     await this.engagementChart();
      // },
      setStatus: function(status) {
          return setRequestStatus(status);
      },
      redirectUrls: function(path) {
          window.open((`/engagement/members/${path}`), '_blank');
      },
      topMemberAdvisor: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/members/topMemberAdvisor`;
          if (this.$route.params.community_id || this.selectedCommunity) {
              const communityId = this.$route.params.community_id || (this.selectedCommunity !== 'all' ? this.selectedCommunity : '');    
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/members/topMemberAdvisor/?community_id=${communityId}`;
          }
          this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              if (response.data) {
                  this.topAdvisers = response.data.advisors;
                  this.topMembers = response.data.members;
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      async fetchCommunityName() {
          try {
              if(this.selectedCommunity !== 'all') {
                  const communityUrl = `${process.env.VUE_APP_API_BASE_URL}/dashboard/community/${this.selectedCommunity}`;
                  await this.axios.get(communityUrl, {headers: {'x-access-token': this.token}}).then(response => {
                      this.communityName = response.data.name;
                  });
              }else{
                  this.communityName = '';
              }
          } catch (error) {
              console.error('Error fetching community name:', error);
          }
      }, 
      async fetchCommunityLocation() {
          try {
              if(this.selectedCommunity !== 'all') {
                  const communityUrl = `${process.env.VUE_APP_API_BASE_URL}/dashboard/community/${this.selectedCommunity}/location`;
                  await this.axios.get(communityUrl, {headers: {'x-access-token': this.token}}).then(response => {
                      this.communityLocation = response.data;
                  });
              }else{
                  this.communityLocation = {};
              }
          } catch (error) {
              console.error('Error fetching community location:', error);
          }
      },
      async fetchAllCommunityLocations() {
          try {
              const response = await this.axios.get(
                  `${process.env.VUE_APP_API_BASE_URL}/dashboard/community/location/all`,
                  { headers: { 'x-access-token': this.token } }
              )
              this.allCommunityLocations = response.data;
              this.allCommunityLocations = response.data.map(community => ({
    id: community._id,
    name: community.name,
    position: {
        lat: parseFloat(community.location.latitude),
        lng: parseFloat(community.location.longitude)
    },
    customSettings: community.customSettings,
    location: {
        city: community.location.city,
        state: community.location.state,
        country: community.location.country
    }
}));
            //   console.log("allCommunityLocations:",this.allCommunityLocations);
          } catch (error) {
              console.error('Error fetching community locations:', error)
          }
      },
      topRequestTags: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/request/top-tags/?&limit=25`;
          if (this.$route.params.community_id || this.selectedCommunity) {
              const communityId = this.$route.params.community_id || (this.selectedCommunity !== 'all' ? this.selectedCommunity : '');    
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/request/top-tags/?community_id=${communityId}&limit=25`;
          }
          this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              this.topTags = response.data;
              this.wordList = (this.topTags || []).map(tagObj => [tagObj.tag, tagObj.count]);
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      requestOverDue: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/requestOverDue/?limit=10`;
          if (this.$route.params.community_id) {
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/requestOverDue/?community_id=${this.$route.params.community_id}&limit=10`;
          }
          this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              if (response.data.asks) {
                  this.requests = response.data.asks;
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      requestIncomplete: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/requestIncomplete/?limit=10`;
          if (this.$route.params.community_id) {
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/requestIncomplete/?community_id=${this.$route.params.community_id}&limit=10`;
          }
          this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              if (response.data.asks) {
                  this.incompletedRequests = response.data.asks;
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      showSiteVisitorsTable() {
          const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
          const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
          const timeframe = this.selectedTimeframe || 'monthly';

          let path = `/engagement/visitors`;
          const queryParams = [];

          if (communityId) queryParams.push(`community_id=${communityId}`);
          if (circle) queryParams.push(`circle=${circle}`);
          queryParams.push(`timeframe=${timeframe}`);

          if (timeframe === 'custom' && this.selectedDates.startDate && this.selectedDates.endDate) {
              queryParams.push(`startDate=${this.dayParam(this.selectedDates.startDate)}`);
              queryParams.push(`endDate=${this.dayParam(this.selectedDates.endDate)}`);
          }

          path += `/?${queryParams.join('&')}`;
          this.$router.push(path);
      },
    // Widget counts default to the last 30 days (see loadDashboardData's `params`),
    // but every widget's target page defaults to ALL TIME when no date is in the
    // URL (requests.vue, responses.vue, EngagementStream.vue, satisfactions.vue all
    // do this independently). Any widget→page link that skips forwarding dates when
    // no custom range is selected will silently show a different number than the
    // widget. Always route through this helper instead of reading
    // this.selectedDates directly.
    //
    // Day-boundary snapping happens server-side now (resolveDateRange(), shared by
    // the Questions/Alumni Contacted widgets and the Stream) — this just needs to
    // send a representative instant, not pre-compute the exact boundary itself.
    //
    // When no custom range is selected, reuse the EXACT startDate/endDate
    // loadDashboardData just used to compute the widgets' own counts (stashed as
    // this._widgetDateRange), instead of computing a fresh "now" here. 
    getWidgetDateRange() {
      if (this.selectedDates.startDate && this.selectedDates.endDate) {
        return {
          startDate: this.dayParam(this.selectedDates.startDate),
          endDate: this.dayParam(this.selectedDates.endDate)
        };
      }
      if (this._widgetDateRange) {
        return this._widgetDateRange;
      }
      const start = lastNDaysStart(30);
      const end = new Date();
      return { startDate: this.dayParam(start), endDate: this.dayParam(end) };
    },
    // Bare "YYYY-MM-DD" date param (toDayParam in common.js) — never an ISO instant,
    // which the server's time-zone snap slid back a day, so widgets counted one more
    // day than the Reports CSV. Custom picks are local calendar days; presets are UTC.
    dayParam(date) {
      return toDayParam(this.isCustomRange ? pickedDayToUtc(date) : date);
    },
    showRequestsTable() {
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
      const timeframe = this.selectedTimeframe || 'monthly';

      let path = `/engagement/requests`;
      const queryParams = [];

      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }
      // Forward timeframe alongside the dates so the Questions page can set its own
      // date-range dropdown to match instead of always showing its hardcoded default
      // ("Last 30 Days") regardless of what range was actually applied.
      queryParams.push(`timeframe=${timeframe}`);
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);

      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }

      this.$router.push(path);
    },
    showAlumniContactedStream() {
      // Pre-select "Delivered Request" — Alumni Contacted only counts that
      // category now, so the stream should open already scoped to match.
      this.navigateToStream('Email Delivered', 'Delivered Request');
    },
    navigateToStream(action, deliveredType) {
      const queryParams = [];

      // Community filter
      const communityId = this.$route.params.community_id || (this.selectedCommunity !== 'all' ? this.selectedCommunity : '');
      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }

      // Circle filter
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }

      // Action/Type filter
      if (action) {
          queryParams.push(`action=${encodeURIComponent(action)}`);
      }

      // "Email Delivered" category sub-filter — only meaningful alongside that action.
      if (action === 'Email Delivered' && deliveredType) {
          queryParams.push(`deliveredType=${encodeURIComponent(deliveredType)}`);
      }

      // Email Opens/Clicks widgets show unique counts — open the Stream's matching view.
      if (action === 'Email Open' || action === 'Email Click') {
          queryParams.push('view=unique');
      }

      // Date range filter — always pass dates so the stream shows the same window as the widget
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`);
      queryParams.push(`endDate=${endDate}`);

      // Pass the date preset so the stream datepicker shows the same label as Dashboard home
      // selectedTimeframe is never literally 'last-30' — the dashboard's own date picker
      // normalizes that preset to 'monthly' (see its `changed` handler) — so the map has
      // to key on 'monthly', or this silently never matches and the preset never forwards.
      // 'custom' and 'all' are forwarded too: without them the Stream's picker fell back
      // to "Last 30 Days" while the table used the forwarded range, so re-applying the
      // label's filter in the Stream gave a different count than the widget.
      const presetMap = { weekly: 'last-7', monthly: 'last-30', ytd: 'ytd', custom: 'custom', all: 'all' };
      const preset = presetMap[this.selectedTimeframe];
      if (preset) queryParams.push(`preset=${preset}`);

      let path = '/engagement/stream';
      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }
      this.$router.push(path);
    },
    showEmailOpensStream() {
      this.navigateToStream('Email Open');
    },
    showEmailClicksStream() {
      this.navigateToStream('Email Click');
    },
    showResponsesTable() {
      // The widget's own number (engagementRate) comes from this exact same query
      // builder (buildResponseQueries, response.controller.js) called with
      // action=accepted — so forwarding action=accepted here guarantees the table
      // reproduces the identical query, not just an approximation of it.
      //
      // startDate/endDate are always forwarded below (not just for timeframe=custom)
      // since responses.vue now honors them for any timeframe — see its created().
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
      const timeframe = this.selectedTimeframe || 'monthly';

      let path = `/engagement/responses`;
      const queryParams = [];

      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }
      queryParams.push(`action=accepted`);
      queryParams.push(`timeframe=${timeframe}`);
      // Forward the same frozen startDate/endDate the widget's own count (engagementRate)
      // used, not just for 'custom' — otherwise responses.vue recomputes its own fresh
      // "now" for weekly/monthly/ytd and can drift from the widget by a boundary record,
      // same bug class as showAdvisorsEngagedResponses below.
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);

      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }

      this.$router.push(path);
    },
    showAdvisorsEngagedResponses() {
      // This is the actual handler bound to the "Alumni Engaged" widget — do not confuse
      // with showAlumniEngagedResponses() below, which despite the name isn't wired to
      // any widget right now. Dates must always be forwarded (not just for 'custom'
      // timeframe), or responses.vue falls back to its own default of ALL TIME.
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
      const timeframe = this.selectedTimeframe || 'monthly';

      let path = '/engagement/responses';
      const queryParams = [];
      if (communityId) queryParams.push(`community_id=${communityId}`);
      if (circle) queryParams.push(`circle=${circle}`);
      queryParams.push(`timeframe=${timeframe}`);
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);
      if (queryParams.length > 0) path += `/?${queryParams.join('&')}`;
      this.$router.push(path);
    },
    // NOT currently bound to any widget's @click — the "Alumni Engaged" card actually
    // uses showAdvisorsEngagedResponses() above, despite the name similarity. Kept
    // correct (dates included) in case something wires it up later; don't assume the
    // name means it's live.
    showAlumniEngagedResponses() {
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';

      let path = '/engagement/responses';
      const queryParams = [];

      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);

      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }

      this.$router.push(path);
  },

  showProspectsEngagedResponses() {
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';

      let path = '/engagement/responses';
      const queryParams = [];

      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }
      const { startDate, endDate } = this.getWidgetDateRange();
      queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);

      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }

      this.$router.push(path);
  },

  showAssignedProspectsEngagedStream() {
      // Same target/action as showAlumniContactedStream — reuse the shared
      // helper so date-forwarding stays correct in one place.
      this.navigateToStream('Email Delivered');
  },
  
  showActivatedAlumniResponses() {
      const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
      const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
      const action = 'accepted';
      
      let path = '/engagement/responses';
      const queryParams = [];
      
      if (communityId) {
          queryParams.push(`community_id=${communityId}`);
      }
      if (circle) {
          queryParams.push(`circle=${circle}`);
      }
      if (action) {
          queryParams.push(`action=${action}`);
      }
      
      if (queryParams.length > 0) {
          path += `/?${queryParams.join('&')}`;
      }
      
      this.$router.push(path);
  },
  
  showActivatedProspectsStream() {
      // Same target/action as showEmailClicksStream — reuse the shared
      // helper so date-forwarding stays correct in one place.
      this.navigateToStream('Email Click');
  },
  
  showDonorAlertsStream() {
      this.navigateToStream('Donor Alert');
  },
  showFeedback() {
    const communityId = this.selectedCommunity !== 'all' ? this.selectedCommunity : '';
    const circle = this.circleShortName && this.circleShortName !== 'all' ? this.circleShortName : '';
    const timeframe = this.selectedTimeframe || 'monthly';
    let path = '/engagement/feedback';
    const queryParams = [];
    if (communityId) {
        queryParams.push(`community_id=${communityId}`);
    }
    if (circle) {
        queryParams.push(`circle=${circle}`);
    }
    // Forward timeframe alongside the dates so the Feedback page can set its own
    // date-range dropdown to match instead of always showing its hardcoded default
    // ("Last 30 Days") regardless of what range was actually applied.
    queryParams.push(`timeframe=${timeframe}`);
    const { startDate, endDate } = this.getWidgetDateRange();
    queryParams.push(`startDate=${startDate}`, `endDate=${endDate}`);
    if (queryParams.length > 0) {
        path += `/?${queryParams.join('&')}`;
    }
    this.$router.push(path);
  },
  showProfileUpdates() {
      this.navigateToStream('Update Profile');
  },
      reqResApproval: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/reqResApproval/?limit=5`;
          if (this.$route.params.community_id) {
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/reqResApproval/?community_id=${this.$route.params.community_id}&limit=5`;
          }
          await this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              if (response.data.reqApproval) {
                  this.requestApproval = response.data.reqApproval
              }
              if (response.data.resApproval) {
                  this.responseApproval = response.data.resApproval;
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      getRejectRequestResponse: async function() {
          let url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/get-reject-request-response/?limit=5`;
          if (this.$route.params.community_id) {
              url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/get-reject-request-response/?community_id=${this.$route.params.community_id}&limit=5`;
          }
          await this.axios.get(url, {headers: {'x-access-token': this.token}}).then(async response => {
              if (response.data.reqReject) {
                  this.requestReject = response.data.reqReject
              }
              if (response.data.resReject) {
                  this.responseReject = response.data.resReject;
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      getAdvice: function(advice) {
          if(advice.length > 88) {
              return advice.substr(0, 88) + '...';
          } else {
              return advice;
          }
      },
      approveRequest: function(askId, action, status) {
          let params = {
              askId: askId,
              action: action,
              status: status,
              approvedBy: 'dashboard'
          }
          if (this.authUser.memberID) {
              params.adminId = this.authUser.memberID;
          }
          this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/request-approval`, params, {headers: {'x-access-token': this.token}}).then(async response => {
              await this.reqResApproval();
              if (action == 'approve') {
                  this.showSuccessMsg({message: 'Thank you for approving the request.'})
              } else if (action == 'reject') {
                  this.showSuccessMsg({message: 'Thank you for your response'})
              }
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      approveResponse: function(askId, giveId, action, status) {
          let params = {
              askId: askId,
              giveId: giveId,
              action: action,
              status: status,
              approvedBy: 'dashboard'
          }
          if (this.authUser.memberID) {
              params.adminId = this.authUser.memberID;
          }
          this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response-approval`, params, {headers: {'x-access-token': this.token}}).then(async response => {
              setTimeout(async () => {
                  await this.reqResApproval();
                  if (action == 'approve') {
                      this.showSuccessMsg({message: 'Thank you for approving the response.'})
                  } else if (action == 'reject') {
                      this.showSuccessMsg({message: 'Thank you for your response'})
                  }
              }, 2000);
          }).catch(err => {
              if (err.response.status  === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
          });
      },
      openResponseModal: function(advice) {
          this.responseModal = true;
          this.giveAdvice = advice;
      },
      getWidgetData: async function(version) {
          if (version !== undefined && this._loadDataVersion !== version) return;

          const communityId = this.$route.params.community_id || (this.selectedCommunity !== 'all' ? this.selectedCommunity : '');
          const circle = !this.selectedCircle || this.selectedCircle === 'all' ? '' : this.selectedCircle;
          // Default to the last 30 days when no custom range is selected. Without this,
          // startDate/endDate go out as empty strings, and resolveDateRange() treats an
          // empty value as "not given" — falling back to its own default of epoch-to-now,
          // i.e. all time. That's what was making Email Open/Click show all-time totals.
          //
          // Reuse this._widgetDateRange (stashed by loadDashboardData, which calls this
          // method) instead of computing a fresh Date.now()-based range here — this is
          // the same widget-vs-target-page timing gap fixed for Alumni Engaged: Email
          // Opens' own count and the Stream page it links to (via navigateToStream(),
          // which already reads getWidgetDateRange()/_widgetDateRange) must be computed
          // from the literal same instant, or a boundary event can land in one but not
          // the other (confirmed: widget 2040 vs Stream 2041).
          let startDate, endDate;
          if (this.selectedDates.startDate && this.selectedDates.endDate) {
              startDate = this.dayParam(this.selectedDates.startDate);
              endDate = this.dayParam(this.selectedDates.endDate);
          } else if (this._widgetDateRange) {
              ({ startDate, endDate } = this._widgetDateRange);
          } else {
              startDate = this.dayParam(lastNDaysStart(30));
              endDate = this.dayParam(new Date());
          }
          const circleShortName = this.circleShortName ;

          const params = {
          community_id: communityId,
          circle: circle,
          circleShortName: circleShortName,
          startDate: startDate,
          endDate: endDate
      };
      // Run Email Opens and Email Clicks in parallel — they are independent queries.
      // Previously these were sequential awaits (opens first, then clicks), adding
      // both response times together. Promise.all fires both simultaneously and waits
      // for the slower one, cutting the combined wait tim e in half.
      const [opensResponse, clicksResponse] = await Promise.all([
          this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/getAllEngagement`, {
              params: {
                  type: 'Email Open',
                  community: communityId || 'all',
                  circle: circleShortName || 'all',
                  startDate: startDate,
                  endDate: endDate,
                  location: 'dashboard'
              },
              headers: {'x-access-token': this.token}
          }).catch(err => {
              if (err.response && err.response.status === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
              return null;
          }),
          this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/getAllEngagement`, {
              params: {
                  type: 'Email Click',
                  community: communityId || 'all',
                  circle: circleShortName || 'all',
                  startDate: startDate,
                  endDate: endDate,
                  location: 'dashboard'
              },
              headers: {'x-access-token': this.token}
          }).catch(err => {
              if (err.response && err.response.status === 401) {
                  localStorage.removeItem('authUser');
                  this.$router.push('/login');
              }
              return null;
          })
      ]);

      if (this._loadDataVersion !== version) return;

      if (opensResponse && opensResponse.data) {
          this.emailOpen = opensResponse.data.engagementCount.uniqueCount || 0;
          this.emailOpenPercentage = opensResponse.data.engagementCount.percentage;
      }
      if (clicksResponse && clicksResponse.data) {
          this.clickCount = clicksResponse.data.engagementCount.uniqueCount || 0;
          this.emailClickPercentage = clicksResponse.data.engagementCount.percentage;
      }

      if (this._loadDataVersion !== version) return;

          // Always reuse the startDate/endDate already resolved above (custom range,
          // else the frozen _widgetDateRange, else the 30-day default) instead of
          // recomputing a fresh "now" here — a second independent "now" computed at
          // this point (after the Email Opens/Clicks awaits above) can land on a
          // different calendar day than the rest of the widgets once resolveDateRange()
          // snaps it server-side, producing an off-by-one vs. the Responses table
          // (confirmed: widget vs. table, off by exactly the boundary record).
          const customParams = {
              community: communityId || 'all',
              location: 'dashboard',
              action: 'accepted',
              startDate: startDate,
              endDate: endDate,
              // circle (this.selectedCircle) is the circle's _id, not its short name — the
              // backend's sourceparam match (buildResponseQueries) compares against the short
              // name (e.g. "duke_fuqua"), so sending the _id here never matched any Ask and
              // silently zeroed out engagementRate ("Responses" widget) whenever a circle was
              // selected. circleShortName is the same already-resolved short name every other
              // widget request on this page uses.
              circle: circleShortName || 'all',
              limit: 1
          }
          this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response`, {params: customParams, headers: {'x-access-token': this.token}}).then(response => {
              if (this._loadDataVersion !== version) return;
              if (response.data) {
                  this.engagementRate = response.data.askCount || 0;
              }
          });
        //   this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/engagement_rate/`, {params, headers: {'x-access-token': this.token}}).then(response => {
        //       if (response.data) {
        //           this.engagementRate = response.data.engagementRate;
        //       }
        //   });
        //   this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/first_response/`, {params, headers: {'x-access-token': this.token}}).then(async response => {
        //       if (response.data) {
        //           this.firstResponse = response.data.time;
        //       }
        //   });
        //   this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response_per_request/`, {params, headers: {'x-access-token': this.token}}).then(async response => {
        //       if (response.data) {
        //           this.responsePerRequest = response.data.count ? response.data.count : 0;
        //           this.responsePerRequestPercentage = response.data.percentage;
        //       }
        //   });
        //   this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/satisfaction_avg/`, {params, headers: {'x-access-token': this.token}}).then(async response => {
        //       if (response.data) {
        //           this.satisfactionData = response.data;
        //           this.satisfactionDataPercentage = Math.round(this.satisfactionData * 100 / 10);
        //       }
        //   });
        //   this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/update_profile`, {params,headers: {'x-access-token': this.token}}).then(async response => {
        //       if (response.data) {
        //           this.profileUpdate = response.data.count;
        //       }
        //   });
      },
      tagRequest: function(tag) {
          window.open((`/engagement/requests/?tag=${tag}`), '_blank');
      },
    //   requestResponseChart: async function() {
    //       let data = [];
    //       let arr = [];
    //       await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/response_type/?community_id=${this.$route.params.community_id ? this.$route.params.community_id: ''}`, { headers: {'x-access-token': this.token}}).then(response => {
    //           for (let i = 0; i < response.data.length; i++) {
    //               if (response.data[i]._id == 'Share Advice') {
    //                   arr[0] = response.data[i].count;
    //                   // count += response.data[i].count;
    //               } else if (response.data[i]._id == 'Call Me') {
    //                   arr[1] = response.data[i].count;
    //                   // count += response.data[i].count;
    //               } else if (response.data[i]._id == "Let's Connect") {
    //                   arr[2] = response.data[i].count;
    //                   // count += response.data[i].count;
    //               }
    //           }
    //           this.dataPieChart2 = [...arr];
    //           this.piaChartData2.datasets[0].data = arr;
    //       });
    //       await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/request_engagement/?community_id=${this.$route.params.community_id ? this.$route.params.community_id: ''}`, { headers: {'x-access-token': this.token}}).then(response => {
    //           for (let i = 0; i < response.data.length; i++) {
    //               if (response.data[i]._id == 'first_email_advisor') {
    //                   data[0] = response.data[i].count;
    //               } else if (response.data[i]._id == 'first_reminder_advisor') {
    //                   data[1] = response.data[i].count;
    //               } else if (response.data[i]._id == "second_reminder_advisor") {
    //                   data[2] = response.data[i].count;
    //               }
    //           }
    //           this.dataPieChart1 = [...data];            
    //           this.piaChartData1.datasets[0].data = data;
    //           this.addListenerToPieChart();
    //       });
    //   },
      openRequestInNewTab(path,requestType = '') {
          if (requestType == 'incomplete') {
              window.open((`/engagement/incomplete-requests/${path}`), '_blank');
          } else {
              window.open((`/engagement/requests/${path}`), '_blank');
          }
      },
      showResponse: function(response) {
        let returnResponse = response.response_Action;
        if(response.advice) {
          returnResponse += `\n\n${response.advice}`;
        }
        return returnResponse;
      },
      addListenerToPieChart: function() {
          const pieChart = document.querySelectorAll(".pie-chart");
          pieChart.forEach(element => {
              element.addEventListener("focus",(event) => {
                  var targetID = event.target.id;
                  this.makeAnnouncement(targetID);
              });
          });
      },
      makeAnnouncement: function(targetID) {
          var tableContent;
          if(targetID == 'request-pie-chart'){
              tableContent = document.getElementsByClassName("request-table")[0]; 
          }else if(targetID == 'response-pie-chart'){
              tableContent = document.getElementsByClassName("response-table")[0];
          }
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('role', 'alert');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.innerText = tableContent.innerText;
        document.body.appendChild(liveRegion);
        setTimeout(() => {
          liveRegion.remove();
        },1000)
      }
    }
}
</script>
<style>
.chart-wrapper {
    height: 300px;
}

.widget-wrapper {
    cursor: pointer;
}

.enlarged-number {
    font-size: 2.5em;
    font-weight: 800 !important;
}

.enlarged-description {
    font-size: 0.9em;
    font-weight: 500 !important;
}
</style>